import { all_routes } from "../../../router/backendComponents/website/all_routes";
const route = all_routes;

export const SidebarData = [
  {
    submenuItems: [
      {
        label: "Pages Overview",
        icon: "ti ti-layout-2",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          { label: "About US", link: route.aboutUs, showSubRoute: false },
          { label: "Contact US", link: route.contactUs, showSubRoute: false },
          {
            label: "Term & Condition",
            link: route.termCondition,
            showSubRoute: false,
          },
        ],
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Social Media",
        icon: "ti ti-social",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "News Letter",
            link: route.newsLetter,
            showSubRoute: false,
          },
          {
            label: "Google Map",
            link: route.googleMap,
            showSubRoute: false,
          },
          {
            label: "Social Media",
            link: route.socialMedia,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
  {
    submenuItems: [
      {
        label: "Manage Account",
        icon: "ti ti-users",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          {
            label: "Forget Password",
            link: route.forgetPassword,
            showSubRoute: false,
          },
          {
            label: "Register Users",
            link: route.manageVendorRegisterInfo,
            showSubRoute: false,
          },

          {
            label: "Billing and Shipping",
            link: route.billingShipping,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
  {
    submenuItems: [
      {
        label: "Manage Order",
        icon: "ti ti-shopping-bag",
        submenu: true,
        showSubRoute: false,
        submenuItems: [
          { label: "Review & Rating", link: route.rating, showSubRoute: false },
          {
            label: "Special Offers",
            link: route.specialOffer,
            showSubRoute: false,
          },
          {
            label: "Quotation / Enquiry",
            link: route.orderEnquery,
            showSubRoute: false,
          },
          {
            label: "Wish List",
            link: route.wishList,
            showSubRoute: false,
          },
          {
            label: "Cart",
            link: route.cart,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
  {
    submenuItems: [
      {
        label: "Setting",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-settings",
        submenuItems: [
          { label: "News & Blogs", link: route.news, showSubRoute: false },
          {
            label: "Sliders",
            link: route.bannerSlider,
            showSubRoute: false,
          },
          {
            label: "Gallary",
            link: route.gallary,
            showSubRoute: false,
          },
          {
            label: "Our Team",
            link: route.team,
            showSubRoute: false,
          },
          {
            label: "App Logo",
            link: route.appLogo,
            showSubRoute: false,
          },
          {
            label: "Runing Text",
            link: route.runingText,
            showSubRoute: false,
          },
        ],
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Catelogue",
        icon: "ti ti-list-details",
        link: route.catelogue,
        showSubRoute: false,
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Column Approval",
        icon: "ti ti-medical-cross",
        link: route.columnApproval,
        showSubRoute: false,
      },
    ],
  },

  {
    submenuItems: [
      {
        label: "Contact Us Request",
        icon: "ti ti-phone-call",
        link: route.contactRequest,
        showSubRoute: false,
      },
    ],
  },

  {
    label: "",
    showSubRoute: false,
    submenu: true,
    submenuHdr: "Customer Service",
    icon: "ti ti-headset",
    submenuItems: [
      {
        label: "Support",
        submenu: true,
        showSubRoute: false,
        icon: "ti ti-message-circle",
        submenuItems: [
          { label: "FAQs", link: route.faq, showSubRoute: false },
          {
            label: "Feedback",
            link: route.feedback,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
];
